//.NET10后端地址（开发环境）
// export const DO_NET_URL="http://192.168.1.12:6869/";
// export const FILE_URL="http://192.168.1.12:2222/";

//.NET10后端地址（生产环境）n3
export const DO_NET_URL=window.DO_NET_URL;
export const FILE_URL=window.FILE_URL;

//弹出提示框
export function toask(msg,time){
    let div=document.createElement("div")
    div.setAttribute("id","toask1")
    div.style.width="200px"
    div.style.padding="10px 0px"
    div.style.textAlign="center"
    div.style.position="absolute"
    div.style.margin="auto"
    div.style.height="20px"
    div.style.top="0"
    div.style.bottom="0"
    div.style.left="0"
    div.style.right="0"
    div.style.fontSize="12px"
    div.style.backgroundColor="rgba(0,0,0,0.5)"
    div.style.borderRadius="6px"
    div.style.color="white"
    div.style.zIndex="999"
    div.innerHTML=msg
    document.body.appendChild(div)
    setTimeout(function (){
        document.getElementById("toask1").remove()
    },time*100)
}

//弹出等待框
export function loading(msg){
    let div=document.createElement("div")
    div.setAttribute("id","loading1")
    div.style.width="200px"
    div.style.padding="10px 0px"
    div.style.textAlign="center"
    div.style.position="absolute"
    div.style.margin="auto"
    div.style.height="20px"
    div.style.top="0"
    div.style.bottom="0"
    div.style.left="0"
    div.style.right="0"
    div.style.fontSize="12px"
    div.style.backgroundColor="rgba(0,0,0,0.5)"
    div.style.borderRadius="6px"
    div.style.color="white"
    div.style.zIndex="999"
    div.innerHTML=msg
    document.body.appendChild(div)
}

//关闭等待框
export function closeLoading(){
    document.getElementById("loading1").remove()
}

//日期格式转换
export function convertDateToISO(dateStr) {
    const date = new Date(dateStr); // 将字符串转换为Date对象
    date.setDate(date.getDate() + 1);
    const isoDate = date.toISOString(); // 转换为ISO格式的字符串
    return isoDate.substring(0, 10); // 截取前10个字符（yyyy-MM-dd）
}